export const isErrorResponse = (response: Response): boolean => {
	return response.status >= 400
}
